<ion-header class="site-header ion-no-border">
  <div class="demo-notice" role="note">
    {{ (settings$ | async)?.highlight_notes || defaultHighlightNotes }}
  </div>

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button *ngIf="backLink" class="mobile-back-start" [routerLink]="backLink" aria-label="Go back">
        <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
      <ion-menu-button *ngIf="!backLink" class="mobile-menu-start" aria-label="Open navigation"></ion-menu-button>
    </ion-buttons>

    <ion-title [routerLink]="['/home']" class="logo-title">
      <img
        src="assets/images/logo.png"
        alt="Safarizine - Safari and Nature Experience"
        class="header-logo-img" />
    </ion-title>

    <ion-buttons slot="end" class="mobile-actions">
      <ion-button [routerLink]="[bookingInfoLink]" aria-label="Booking information">
        <ion-icon name="calendar-outline" slot="icon-only"></ion-icon>
      </ion-button>
      <ion-menu-button class="tablet-menu-end" aria-label="Open navigation"></ion-menu-button>
    </ion-buttons>

    <nav slot="end" class="desktop-nav">
      <ion-button
        *ngFor="let item of navItems"
        fill="clear"
        size="small"
        [routerLink]="item.url"
        routerLinkActive="active-link">
        {{ item.title }}
      </ion-button>
    </nav>
  </ion-toolbar>
</ion-header>
